import { render, staticRenderFns } from "./coupon_management.vue?vue&type=template&id=62aa5d31&scoped=true"
import script from "./coupon_management.vue?vue&type=script&lang=js"
export * from "./coupon_management.vue?vue&type=script&lang=js"
import style0 from "./coupon_management.vue?vue&type=style&index=0&id=62aa5d31&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62aa5d31",
  null
  
)

export default component.exports